// Raul's Figma design: the "Worn By Thousands" centred carousel and the phone review slider. No dependencies.
(() => {
  const init = (scope) => {
    // Worn By Thousands: the active slide sits in the centre, larger; arrows and taps on a side slide move it.
    scope.querySelectorAll('[data-fg-ugc]').forEach((root) => {
      if (root.dataset.fgReady) return;
      root.dataset.fgReady = '1';
      const track = root.querySelector('[data-fg-track]');
      const slides = [...root.querySelectorAll('[data-fg-slide]')];
      const quote = root.querySelector('[data-fg-quote]');
      if (!track || !slides.length) return;
      let active = Math.min(Math.floor(slides.length / 2), slides.length - 1);
      const place = () => {
        slides.forEach((s, i) => {
          s.classList.toggle('is-active', i === active);
          s.setAttribute('aria-current', i === active ? 'true' : 'false');
          const v = s.querySelector('video');
          if (v && i !== active && !v.paused) v.pause();
        });
        // centre the active slide: measure with its final (active) size from CSS
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const small = slides.find((s, i) => i !== active)?.getBoundingClientRect().width || 0;
        const big = parseFloat(getComputedStyle(slides[active]).width) || 0;
        const offset = active * (small + gap) + big / 2;
        track.style.transform = `translateX(${-offset}px)`;
        if (quote) quote.textContent = slides[active].dataset.quote || '';
      };
      const go = (i) => { active = (i + slides.length) % slides.length; place(); };
      root.querySelectorAll('[data-fg-prev]').forEach((b) => b.addEventListener('click', () => go(active - 1)));
      root.querySelectorAll('[data-fg-next]').forEach((b) => b.addEventListener('click', () => go(active + 1)));
      slides.forEach((s, i) => s.addEventListener('click', (e) => {
        if (i !== active) { e.preventDefault(); go(i); return; }
        const v = s.querySelector('video');
        if (v && e.target.closest('[data-fg-play], video')) {
          const btn = s.querySelector('[data-fg-play]');
          if (v.paused) { v.muted = false; v.play(); if (btn) btn.hidden = true; } else { v.pause(); if (btn) btn.hidden = false; }
        }
      }));
      // after the active slide grows, re-centre once the size transition ends
      track.addEventListener('transitionend', (e) => { if (e.propertyName === 'width') place(); });
      window.addEventListener('resize', place);
      place();
    });

    // What Customers Say on phones: cards scroll sideways, dots follow, arrows move one card.
    scope.querySelectorAll('[data-fg-reviews]').forEach((root) => {
      if (root.dataset.fgReady) return;
      root.dataset.fgReady = '1';
      const cards = root.querySelector('[data-fg-cards]');
      const dots = [...root.querySelectorAll('[data-fg-dots] span')];
      if (!cards) return;
      const step = () => (cards.firstElementChild?.getBoundingClientRect().width || 280) + 20;
      const sync = () => {
        const i = Math.round(cards.scrollLeft / step());
        dots.forEach((d, k) => d.classList.toggle('is-active', k === Math.min(i, dots.length - 1)));
      };
      cards.addEventListener('scroll', sync, { passive: true });
      root.querySelector('[data-fg-prev]')?.addEventListener('click', () => cards.scrollBy({ left: -step(), behavior: 'smooth' }));
      root.querySelector('[data-fg-next]')?.addEventListener('click', () => cards.scrollBy({ left: step(), behavior: 'smooth' }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  // theme editor: sections re-render in place
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
